const roundValueToGivenNumDecimalPlaces = (num, numDecimalPlaces) => {
  if(numDecimalPlaces > 10){
    numDecimalPlaces = 10
  }
  return + (Math.round(num + `e+${numDecimalPlaces}`)  + `e-${numDecimalPlaces}`);
}

export default roundValueToGivenNumDecimalPlaces;
